webpackJsonp([225460204399620],{

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PatternConstruction = __webpack_require__(22);
	
	var _PatternConstruction2 = _interopRequireDefault(_PatternConstruction);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(99);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _PatternConstruction2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Review the Application'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll familiarize ourselves with the application we\'ll be using.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'View the Application'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Now that the application is built, and the mock server is running, you can view the application by navigating to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'http://localhost:3000'
	      ),
	      '. Once you do, you should see this:'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The application is pretty basic. There\'s a Feed that displays a list of tweets, and you can create new tweets, as well as edit and delete existing tweets.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Additionally, when you create a tweet, it will immediately show up at the top of the Feed. There is no pagination or infinite scrolling for this application.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Feel free to try out the application. Each of the actions you can perform (create, edit, and delete) will launch a dialog. The location of the code for each dialog is shown below:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'The ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'create'
	        ),
	        ' dialog is located at ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'src/dialogs/tweet/create/index.js'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'The ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'edit'
	        ),
	        ' dialog is located at ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'src/dialogs/tweet/update/index.js'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'The ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'delete'
	        ),
	        ' dialog is located at ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'src/dialogs/tweet/destroy/index.js'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Currently each of the dialogs is very explicit. The code is all vanilla React - there are no libraries or abstractions of any kind. So if you\'re familiar with building forms in React, it will hopefully look familiar.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Tutorial Goal'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Over the course of this tutorial, we\'re going to refactor each of those dialogs, starting with the create dialog.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the process, we will also gradually build up and explain the pattern that Lore uses for hooks like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-hook-forms-bootstrap'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-hook-dialogs-bootstrap'
	      ),
	      ', the latter of which is used in the Quickstart (though at the time there was no explanation of how it worked).'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Each of Lore\'s form-related hooks are able to generate some non-trivial forms and dialogs from a configuration object, and by the end of this tutorial you will understand how they work, and how to build your own version of one, should you choose to.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../../create/step-1/' },
	        'add a create dialog'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-forms-pattern-setup-step-3-js-867ca6858345c9b65888.js